import { usePageMeta } from "../hooks/usePageMeta";
import { FadeIn } from "../components/site/FadeIn";
import { SectionHeading } from "../components/site/SectionHeading";
import { TimelineItem } from "../components/site/TimelineItem";
import { ImagePlaceholder } from "../components/site/ImagePlaceholder";
import { CONFIG } from "../data/config";
import { BIO_PARAGRAPHS, APPOINTMENTS, EDUCATION, AWARDS, SERVICE, PRESS } from "../data/about";

const ListSection = ({ eyebrow, title, items }) => (
  <section className="section" style={{ paddingTop: 0 }}>
    <div className="container-site">
      <FadeIn>
        <SectionHeading eyebrow={eyebrow} title={title} />
      </FadeIn>
      <ul className="m-0 p-0">
        {items.map((a) => (
          <li key={a} className="body-default py-3" style={{ borderBottom: "1px solid var(--border-default)", listStyle: "none" }}>
            {a}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default function About() {
  usePageMeta(
    "About — Keyur Sorathia",
    "Associate Professor, Department of Design, IIT Guwahati. Founder of the Embedded Interaction Lab and MadVR Solutions."
  );
  return (
    <div data-testid="about-page">
      <section className="section">
        <div className="container-site grid grid-cols-1 lg:grid-cols-[1fr_420px] gap-12 items-start">
          <FadeIn>
            <h1 className="text-h1 mb-8" style={{ color: "var(--navy-700)" }}>Keyur Sorathia, PhD</h1>
            <ImagePlaceholder file="portrait-keyur.jpg" ratio="420 / 520" label="Portrait of Keyur Sorathia" className="lg:hidden mb-8" />
            {BIO_PARAGRAPHS.map((p) => (
              <p key={p.slice(0, 24)} className="body-default measure mb-5">{p}</p>
            ))}
            <div className="flex flex-wrap gap-6 mt-8">
              <a href={CONFIG.cvOnePage} className="link-default font-medium" data-testid="about-cv-one-page">Download the one-page CV, PDF</a>
              <a href={CONFIG.cvFull} className="link-default font-medium" data-testid="about-cv-full">Download the full CV, PDF</a>
              <a href={CONFIG.scholarUrl} target="_blank" rel="noopener noreferrer" className="link-default font-medium" data-testid="about-scholar">Google Scholar</a>
            </div>
          </FadeIn>
          <FadeIn className="hidden lg:block">
            <ImagePlaceholder file="portrait-keyur.jpg" ratio="420 / 520" label="Portrait of Keyur Sorathia" />
          </FadeIn>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Appointments" title="Appointments and leadership" />
          </FadeIn>
          <ul className="m-0 p-0" data-testid="appointments-timeline">
            {APPOINTMENTS.map((item) => (
              <TimelineItem key={`${item.role}-${item.years}`} item={item} />
            ))}
          </ul>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Training" title="Education and training" />
          </FadeIn>
          <ul className="m-0 p-0" data-testid="education-timeline">
            {EDUCATION.map((item) => (
              <TimelineItem key={item.role} item={item} />
            ))}
          </ul>
        </div>
      </section>

      <ListSection eyebrow="Recognition" title="Awards" items={AWARDS} />
      <ListSection eyebrow="Service" title="Service to the field" items={SERVICE} />
      <ListSection eyebrow="Press" title="Press" items={PRESS} />
    </div>
  );
}
